import Text from '@ui/text/text/text';

const CastAndCrewHeader = () => {
  return (
    <div data-component="CasAndCrewHeader">
      <Text tag="h4" className="H4" design="GlobalIcoText1">
        Cast & Crew
      </Text>
    </div>
  );
};

export default CastAndCrewHeader;
